import ActionButton from '../index';

import image from './images/roles.png';
import styles from './style.scss';

const label = 'Roles';

export default ActionButton.generate({ label, image, styles });
